/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_KoreanInputs */



/**
* | output |
* | --- |
* | "Korean" |
*
* @param {Speechmatics_Target_Language_KoreanInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_korean = /** @type {((inputs?: Speechmatics_Target_Language_KoreanInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_KoreanInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Coreen")
	if (locale === "de") return /** @type {LocalizedString} */ ("Koreanisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("coreano")
	if (locale === "ru") return /** @type {LocalizedString} */ ("корейский")
	if (locale === "es") return /** @type {LocalizedString} */ ("coreano")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("韩国人")
	if (locale === "ja") return /** @type {LocalizedString} */ ("韓国語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोरियाई")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("coreano")
	return /** @type {LocalizedString} */ ("Korean")
});